<template>
  <div class="sci-view-container">
    <header class="sci-header">
      <div class="sci-header-left">
        <button class="sci-btn-back" @click="home">
          <i class="fas fa-arrow-left"></i>
          <span>{{ $t('gestionale') || 'Gestionale' }}</span>
        </button>
        <div class="sci-title-group">
          <h1 class="sci-title">
            <i class="fas fa-share-alt me-2 text-primary"></i>
            {{ $t('gestioneSocial') || 'Social Media Marketing Hub' }}
          </h1>
          <p class="sci-subtitle">Pianifica post su Instagram e Facebook, crea campagne social e monitora l'engagement</p>
        </div>
      </div>
    </header>

    <div class="social-content-wrap">
      <SocialDashboard />
    </div>
  </div>
</template>

<script>
import SocialDashboard from '@/components/social/SocialDashboard.vue'

export default {
  name: 'Social',
  components: {
    SocialDashboard
  },
  methods: {
    home() {
      this.$router.push({ name: "Gestionale" });
    }
  }
}
</script>

<style scoped>
.sci-view-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--sci-bg, #f8fafc);
  color: var(--sci-text-main, #0f172a);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

/* Header */
.sci-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 28px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--sci-border, #e2e8f0);
}

.sci-header-left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.sci-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  background: #ffffff;
  border: 1px solid var(--sci-border, #e2e8f0);
  border-radius: 12px;
  color: var(--sci-text-muted, #475569);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.sci-btn-back:hover {
  background: #f1f5f9;
  color: var(--sci-text-main, #0f172a);
  border-color: #cbd5e1;
}

.sci-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
}

.sci-subtitle {
  margin: 2px 0 0 0;
  font-size: 0.82rem;
  color: var(--sci-text-muted, #475569);
}

.social-content-wrap {
  flex: 1;
}
</style>
